/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Injector} from '../di/injector';
import {NgModuleFactory, NgModuleRef} from '../linker/ng_module_factory';
import {Type} from '../type';

import {initServicesIfNeeded} from './services';
import {NgModuleDefinitionFactory, ProviderOverride, Services} from './types';
import {resolveDefinition} from './util';
/**
 * @param {?} override
 * @return {?}
 */
export function overrideProvider(override: ProviderOverride) {
  initServicesIfNeeded();
  return Services.overrideProvider(override);
}
/**
 * @return {?}
 */
export function clearProviderOverrides() {
  initServicesIfNeeded();
  return Services.clearProviderOverrides();
}
/**
 * @param {?} ngModuleType
 * @param {?} bootstrapComponents
 * @param {?} defFactory
 * @return {?}
 */
export function createNgModuleFactory(
    ngModuleType: Type<any>, bootstrapComponents: Type<any>[],
    defFactory: NgModuleDefinitionFactory): NgModuleFactory<any> {
  return new NgModuleFactory_(ngModuleType, bootstrapComponents, defFactory);
}
class NgModuleFactory_ extends NgModuleFactory<any> {
/**
 * @param {?} moduleType
 * @param {?} _bootstrapComponents
 * @param {?} _ngModuleDefFactory
 */
constructor(
public readonly moduleType: Type<any>,
private _bootstrapComponents: Type<any>[],
private _ngModuleDefFactory: NgModuleDefinitionFactory) {
    // Attention: this ctor is called as top level function.
    // Putting any logic in here will destroy closure tree shaking!
    super();
  }
/**
 * @param {?} parentInjector
 * @return {?}
 */
create(parentInjector: Injector|null): NgModuleRef<any> {
    initServicesIfNeeded();
    const /** @type {?} */ def = resolveDefinition(this._ngModuleDefFactory);
    return Services.createNgModuleRef(
        this.moduleType, parentInjector || Injector.NULL, this._bootstrapComponents, def);
  }
}

function NgModuleFactory__tsickle_Closure_declarations() {
/** @type {?} */
NgModuleFactory_.prototype.moduleType;
/** @type {?} */
NgModuleFactory_.prototype._bootstrapComponents;
/** @type {?} */
NgModuleFactory_.prototype._ngModuleDefFactory;
}




// WEBPACK FOOTER //
// ../../../../packages/core/src/view/entrypoint.ts